import React, { useEffect } from "react"
import { home } from "../data/dummydata"
import Typewriter from "typewriter-effect"

export const Hero = () => {

  return (
    <>
      <section className='hero'>
        {home.map((val, i) => (
          <div className='heroContent'>
            <h3 className='fontSize' data-aos='fade-right'>
              {val.text}
            </h3>
            <h1>
              <Typewriter
                options={{
                  strings: [`${val.name}`, `${val.post}`, `${val.design}`],
                  autoStart: true,
                  loop: true,
                }}
              />
            </h1>
            <p data-aos='fade-left'>{val.desc}</p>
            
            <a
              className="cv__download"
              href="https://drive.google.com/file/d/1Xm9cytGbrrpDqDccwkQT1vZDbWAKoT3P/view?usp=sharing"
              target="_blank" rel="noreferrer"
            >
              View CV
            </a>
          </div>
        ))}
      </section>
    </>
  )
}


